import * as React from "react";
import {Box, Grid} from "@mui/material";
import {useQueryGatherInvoice, useQueryGatherPayback} from "@/service/analyze";
import RecentYearPayback from "@/pages/Analyze/Finance/RecentYearPayback";
import SalesRanking from "@/pages/Analyze/Finance/SalesRanking";
import PaymentMethodDist from "@/pages/Analyze/Finance/PaymentMethodDist";
import ArrivalMoneyDist from "@/pages/Analyze/Finance/ArrivalMoneyDist";
import YearPaybackTrend from "@/pages/Analyze/Finance/YearPaybackTrend";
import PaybackIntervalDist from "@/pages/Analyze/Finance/PaybackIntervalDist";
import InvoiceMoneyTrend from "@/pages/Analyze/Finance/InvoiceMoneyTrend";

export default function AnalyzePage() {
    const {data: gatherPaybackData, isPending: gatherPaybackPending} = useQueryGatherPayback()
    const {data: gatherInvoiceData, isPending: gatherInvoicePending} = useQueryGatherInvoice()
    const gatherPayback = gatherPaybackData?.data
    const gatherInvoice = gatherInvoiceData?.data
    return (
        <Box sx={{width: "100%", maxWidth: {sm: "100%", md: "1700px"}}}>
            <Grid
                container
                spacing={2}
                columns={12}
            >
                <Grid size={{xs: 6, sm: 6, lg: 6}}>
                    <RecentYearPayback loading={gatherPaybackPending} yearPaybacks={gatherPayback?.recentYearPaybacks || []}/>
                </Grid>
                <Grid size={{xs: 6, sm: 6, lg: 6}}>
                    <SalesRanking loading={gatherPaybackPending} sellerYearRanking={gatherPayback?.sellerYearRanking || []}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <PaymentMethodDist loading={gatherPaybackPending} receiveMethods={gatherPayback?.receiveMethods || []} areaPaybacks={gatherPayback?.areaPaybackRanking || []}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <ArrivalMoneyDist loading={gatherPaybackPending} paymentMethods={gatherPayback?.paymentMethods || []} yearPayment={gatherPayback?.recent1YearPayment || []}/>
                </Grid>
                <Grid size={{xs: 6, sm: 4, lg: 4}}>
                    <YearPaybackTrend loading={gatherPaybackPending} lastYearPaybacks={gatherPayback?.lastYearPaybacks || []}
                                      thisYearPaybacks={gatherPayback?.thisYearPaybacks || []}/>
                </Grid>
                <Grid size={{xs: 6, sm: 4, lg: 4}}>
                    <InvoiceMoneyTrend loading={gatherInvoicePending} recent1YearMoney={gatherInvoice?.recent1YearMoney || []}/>
                </Grid>
                <Grid size={{xs: 6, sm: 4, lg: 4}}>
                    <PaybackIntervalDist loading={gatherPaybackPending} intervalPayback={gatherPayback?.intervalPayback || []}/>
                </Grid>
            </Grid>
        </Box>
    );
}
